export class MarketHechoBody {
  securityId: string;
  variationPercentage: number;
  lastPrice: number;
  volume: number;
  operationVolume: number;
  maxPrice: number;
  minPrice: number;
  weightedAveragePrice: number;
  weightedAvgPrice?: number;
  bmvWeightedAvgPrice: number;
  openPrice: number;
  volumeInSixMonths: number;
  lastWithLot: number;
  Time: any; // tslint:disable-line
  ipcParticipationRate: number;
  buyer: string;
  oddLot: string;
  regType: string;
  seller: string;
  typeOper: string;
}
